import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import { projectsApi } from "../../helpers/projects_api_helper";

export const getProjectList = createAsyncThunk("projects/getProjectList", async () => {
    try {
        const response = projectsApi.getProjectList();
        return response;
    } catch (error) {
        return error;
    }
});

export const deleteProjectList = createAsyncThunk("projects/deleteProjectList", async (data:any) => {
    try {
        const response = projectsApi.deleteProjectList(data);
        const newdata = await response;
        toast.success("project-list Delete Successfully", { autoClose: 3000 });
        return newdata;
    } catch (error) {
        toast.error("project-list Delete Failed", { autoClose: 3000 });
        return error;
    }
});